import { Ativo } from "./dtos/Ativo";
import { Ferramenta } from "./dtos/Ferramenta";
import { Funcionario } from "./dtos/Funcionario";

const state = () => ({
  cabecalhoNota: null,
  catalogoUuid: null,
});

const mutations = {
  SALVAR_CABECALHO(state, payload) {
    state.cabecalhoNota = payload;
  },
  SALVAR_CATALOGOUUID(state, payload) {
    state.catalogoUuid = payload;
  },
};

const actions = {
  //Cadastrar Catálogo

  listarCatalogo: async (
    context,
    { unidadeId, nome, page, perPage, catalogoUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/catalogo`, {
      params: {
        unidadeId,
        nome,
        page,
        perPage,
        catalogoUuid,
      },
    });
    return {
      response,
    };
  },

  adicionarCatalogo: async (context, { unidadeId, nome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/catalogo`, {
      unidadeId,
      nome,
    });

    return {
      response,
    };
  },

  editarCatalogo: async (context, { catalogoUuid, nome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/catalogo/${catalogoUuid}`, {
      catalogoUuid,
      nome,
    });

    return {
      response,
    };
  },

  excluirCatalogo: async (context, { catalogoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`atv/catalogo/${catalogoUuid}`, {
      catalogoUuid,
    });

    return {
      response,
    };
  },

  //Catalogo Ferramentas

  listarFerramentas: async (
    context,
    {
      ordenacao,
      catalogoSubGrupoUuid,
      catalogoItemUuid,
      codigo,
      nome,
      unidadeId,
      page,
      perPage,
      catalogoUuid,
      comAcessorios,
      nomeGrupo,
      comAtributos,
      comCheckLists,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/catalogo/item`, {
      params: {
        ordenacao,
        catalogoSubGrupoUuid,
        catalogoItemUuid,
        catalogoUuid,
        codigo,
        nome,
        page,
        perPage,
        comAcessorios,
        comAtributos,
        unidadeId,
        comCheckLists,
        nomeGrupo,
      },
    });
    const listaFerramentas = [];
    response.data.resultado.dados.forEach((value) => {
      listaFerramentas.push(
        new Ferramenta({
          uuid: value.catalogoItemUuid,
          codigo: value.codigo,
          descricao: value.nome,
          grupo: value.catalogoGrupo,
          subgrupo: value.catalogoSubGrupo,
          url: value.urlImagem,
          unidadeMedida: value.unidadeMedida,
          checkLists: value.checkList,
          tempoPermanencia: value.tempoPermanencia,
          atributos: value.atributos,
          acessorios: value.acessorios,
          depositoLocalUuid: value?.depositoLocalUuid,
        })
      );
    });
    return {
      listaFerramentas,
      response,
    };
  },

  adicionarItem: async (
    context,
    {
      catalogoSubGrupoUuid,
      codigo,
      nome,
      unidadeMedida,
      urlImagem,
      tempoPermanencia,
      atributos,
      acessorios,
      checkLists,
      usuarioId,
      usuarioNome,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/catalogo/item`, {
      catalogoSubGrupoUuid,
      codigo,
      nome,
      unidadeMedida,
      urlImagem,
      tempoPermanencia,
      atributos,
      acessorios,
      checkLists,
      usuarioId,
      usuarioNome,
    });

    return {
      response,
    };
  },

  receberUrlUpload: async (context, { catalogoItemUuid, nomeArquivo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `atv/catalogo/item/${catalogoItemUuid}/imagem/url-upload`,
      {
        params: {
          nomeArquivo,
        },
      }
    );

    return {
      response,
    };
  },

  excluirImagemItem: async (context, { catalogoItemUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/catalogo/item/${catalogoItemUuid}/imagem`
    );

    return {
      response,
    };
  },

  editarItem: async (
    context,
    {
      catalogoItemUuid,
      codigo,
      catalogoSubGrupoUuid,
      nome,
      unidadeMedida,
      urlImagem,
      tempoPermanencia,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/catalogo/item/${catalogoItemUuid}`, {
      codigo,
      nome,
      unidadeMedida,
      urlImagem,
      tempoPermanencia,
      catalogoSubGrupoUuid,
    });

    return {
      response,
    };
  },

  excluirItem: async (context, { catalogoItemUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`atv/catalogo/item/${catalogoItemUuid}`);

    return {
      response,
    };
  },

  listarAtributoItem: async (context, { catalogoItemUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `atv/catalogo/item/${catalogoItemUuid}/atributo`
    );

    return {
      response,
    };
  },

  listarAcessorioItem: async (context, { catalogoItemUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `atv/catalogo/item/${catalogoItemUuid}/acessorio`
    );

    return {
      response,
    };
  },

  excluirAcessorioItem: async (context, { uuidAcessorio }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/catalogo/item/acessorio/${uuidAcessorio}`
    );

    return {
      response,
    };
  },

  excluirAtributoItem: async (context, { catalogoItemUuid, chaveAtributo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/catalogo/item/${catalogoItemUuid}/atributo/${chaveAtributo}`
    );

    return {
      response,
    };
  },

  adicionarAtributoItem: async (context, { catalogoItemUuid, atributos }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `atv/catalogo/item/${catalogoItemUuid}/atributo`,
      {
        atributos,
      }
    );

    return {
      response,
    };
  },

  adicionarAcessorioItem: async (context, { catalogoItemUuid, acessorios }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `atv/catalogo/item/${catalogoItemUuid}/acessorio`,
      {
        acessorios,
      }
    );

    return {
      response,
    };
  },

  associarCheckListItem: async (
    context,
    { catalogoItemUuid, checklListUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/catalogo/item/${catalogoItemUuid}/checklist/${checklListUuid}/associar`
    );

    return {
      response,
    };
  },
  desassociarCheckListItem: async (
    context,
    { catalogoItemUuid, checklListUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/catalogo/item/${catalogoItemUuid}/checklist/${checklListUuid}/desassociar`
    );

    return {
      response,
    };
  },
  //Catalogo de ativos

  receberUrlUploadAtivo: async (context, { ativoUuid, nomeArquivo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/${ativoUuid}/imagem/url-upload`, {
      params: {
        nomeArquivo,
      },
    });

    return {
      response,
    };
  },

  listarAtributoAtivo: async (context, { ativoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/${ativoUuid}/atributo`);

    return {
      response,
    };
  },

  alterarImagemAtivo: async (
    context,
    { ativoUuid, urlImagem, usuarioId, usuarioNome }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/ativo/${ativoUuid}/alterar-imagem`, {
      urlImagem,
      usuarioId,
      usuarioNome,
    });

    return {
      response,
    };
  },

  excluirAcessorioAtivo: async (context, { ativoUuid, acessorioUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/ativo/${ativoUuid}/acessorio/${acessorioUuid}`
    );

    return {
      response,
    };
  },

  excluirAtributoAtivo: async (context, { ativoUuid, chaveAtributo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/ativo/${ativoUuid}/atributo/${chaveAtributo}`
    );

    return {
      response,
    };
  },

  adicionarAtributoAtivo: async (context, { ativoUuid, atributos }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/ativo/${ativoUuid}/atributo`, {
      atributos,
    });

    return {
      response,
    };
  },

  adicionarAcessorioAtivo: async (context, { ativoUuid, acessorios }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/ativo/${ativoUuid}/acessorio`, {
      acessorios,
    });

    return {
      response,
    };
  },

  associarCheckListAtivo: async (context, { ativoUuid, checklListUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/ativo/${ativoUuid}/checklist/${checklListUuid}/associar`
    );

    return {
      response,
    };
  },

  desassociarCheckListAtivo: async (context, { ativoUuid, checklListUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/ativo/${ativoUuid}/checklist/${checklListUuid}/desassociar`
    );

    return {
      response,
    };
  },

  excluirAtivo: async (
    context,
    { ativoUuid, usuarioNome, usuarioMatricula }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`atv/ativo/${ativoUuid}`, {
      params: {
        usuarioNome,
        usuarioMatricula,
      },
    });

    return {
      response,
    };
  },

  editarAtivo: async (
    context,
    { ativoUuid, usuarioNome, usuarioId, editar }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/ativo/${ativoUuid}/editar`, {
      usuarioNome,
      usuarioId,
      editar,
    });

    return {
      response,
    };
  },

  vincularDocumentoAtivo: async (context, { ativoUuid, documentoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(
      `atv/ativo/${ativoUuid}/documento/${documentoUuid}`
    );

    return {
      response,
    };
  },

  desvincularDocumentoAtivo: async (context, { ativoUuid, documentoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/ativo/${ativoUuid}/documento/${documentoUuid}`
    );

    return {
      response,
    };
  },

  //Criar novo grupo

  listarGruposCriados: async (
    context,
    {
      unidadeId,
      catalogoUuid,
      catalogoGrupoUuid,
      nome,
      descricao,
      page,
      per_page,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/catalogo/grupo`, {
      params: {
        unidadeId,
        catalogoUuid,
        catalogoGrupoUuid,
        nome,
        descricao,
        page,
        per_page,
      },
    });

    return response;
  },

  listarSubgrupoGrupo: async (
    context,
    { catalogoGrupoUuid, subgrupoUuid, nome, descricao, page, per_page }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/catalogo/grupo/subgrupo`, {
      params: {
        catalogoGrupoUuid,
        subgrupoUuid,
        nome,
        descricao,
        page,
        per_page,
      },
    });

    return response;
  },

  criarGrupo: async (
    context,
    { unidadeId, nome, descricao, catalogoUuid, usuarioId, usuarioNome }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/catalogo/grupo`, {
      unidadeId,
      catalogoUuid,
      nome,
      descricao,
      usuarioId,
      usuarioNome,
    });

    return response;
  },

  editarGrupo: async (context, { catalogoGrupoUuid, nome, descricao }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/catalogo/grupo/${catalogoGrupoUuid}`, {
      nome,
      descricao,
    });

    return response;
  },

  deletarGrupo: async (context, { catalogoGrupoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/catalogo/grupo/${catalogoGrupoUuid}`
    );

    return response;
  },

  criarSubgrupo: async (
    context,
    { catalogoGrupoUuid, nome, descricao, usuarioId, usuarioNome }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/catalogo/grupo/subgrupo`, {
      catalogoGrupoUuid,
      nome,
      usuarioId,
      usuarioNome,
      descricao,
    });

    return response;
  },

  editarSubgrupo: async (
    context,
    { catalogoSubGrupoUuid, nome, descricao }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/catalogo/grupo/subgrupo/${catalogoSubGrupoUuid}`,
      {
        nome,
        descricao,
      }
    );

    return response;
  },

  deletarSubgrupo: async (context, { catalogoSubGrupoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/catalogo/grupo/subgrupo/${catalogoSubGrupoUuid}`
    );

    return response;
  },

  //Recebimento Nota fiscal / Romaneio

  criarAtivoRecebimento: async (
    context,
    { unidadeId, ativos, usuarioId, usuarioNome, etapa }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/ativo`, {
      unidadeId,
      ativos,
      usuarioId,
      usuarioNome,
      etapa,
    });

    return response;
  },

  criarTransferenciaManual: async (
    context,
    {
      unidadeId,
      etapa,
      usuarioId,
      usuarioNome,
      documentoTipo,
      documentoSerie,
      documentoNumero,
      documentoEmissao,
      ativos,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/transferencia/manual`, {
      unidadeId,
      etapa,
      usuarioId,
      usuarioNome,
      documentoTipo,
      documentoSerie,
      documentoNumero,
      documentoEmissao,
      ativos,
    });

    return response;
  },

  //Transferencia Interna/Externa

  criarTransferencia: async (
    context,
    {
      tipo,
      unidadeIdOrigem,
      unidadeIdDestino,
      fornecedorIdOrigem,
      fornecedorIdDestino,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/transferencia`, {
      tipo,
      unidadeIdOrigem,
      unidadeIdDestino,
      fornecedorIdOrigem,
      fornecedorIdDestino,
    });

    return response;
  },

  listarTransferencia: async (
    context,
    {
      ordenacao,
      transferenciaUuid,
      tipo,
      numero,
      status,
      unidadeIdOrigem,
      unidadeIdDestino,
      fornecedorIdOrigem,
      fornecedorIdDestino,
      patrimonio,
      criadoEmInicial,
      criadoEmFinal,
      page,
      perPage,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/transferencia`, {
      params: {
        ordenacao,
        transferenciaUuid,
        tipo,
        numero,
        status,
        unidadeIdOrigem,
        unidadeIdDestino,
        fornecedorIdOrigem,
        fornecedorIdDestino,
        patrimonio,
        criadoEmInicial,
        criadoEmFinal,
        page,
        perPage,
      },
    });

    return response;
  },

  detalharTransferencia: async (context, { transferenciaUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `atv/transferencia/${transferenciaUuid}/detalhar`
    );

    return response;
  },

  detalharTransferenciaSimplificada: async (context, { transferenciaUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `atv/transferencia/${transferenciaUuid}/ativos-agrupados`
    );

    return response;
  },

  editarTransferencia: async (
    context,
    {
      transferenciaUuid,
      pedido,
      solicitacaoCompra,
      documentoTipo,
      documentoSerie,
      documentoEmissao,
      documentoNumero,
      observacao,
      solicitante,
      expedidor,
      transportador,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/transferencia/${transferenciaUuid}/editar`,
      {
        pedido,
        solicitacaoCompra,
        documentoTipo,
        documentoSerie,
        documentoNumero,
        observacao,
        solicitante,
        expedidor,
        transportador,
        documentoEmissao,
      }
    );

    return response;
  },

  buscarUrlAnexoTransferencia: async (
    context,
    { nomeArquivo, transferenciaUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(
      `atv/transferencia/${transferenciaUuid}/anexo/url-upload`,
      {
        params: {
          nomeArquivo,
        },
      }
    );

    return response;
  },

  enviarAnexoTransferencia: async (
    context,
    { transferenciaUuid, urlAnexo, usuarioId, usuarioNome, observacao }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/transferencia/${transferenciaUuid}/anexo`,
      {
        urlAnexo,
        usuarioId,
        usuarioNome,
        observacao,
      }
    );

    return response;
  },

  excluirAnexoTransferencia: async (context, { transferenciaAnexoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/transferencia/anexo/${transferenciaAnexoUuid}`
    );

    return response;
  },

  enviarTransferencia: async (
    context,
    {
      ativosRespostas,
      transferenciaUuid,
      enviador,
      autorizadorId,
      autorizadorNome,
      autorizadorAuthType,
      autorizadorAuthContent,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/transferencia/${transferenciaUuid}/enviar`,
      {
        enviador,
        ativosRespostas,
        autorizadorId,
        autorizadorNome,
        autorizadorAuthType,
        autorizadorAuthContent,
      }
    );

    return response;
  },

  receberTransferencia: async (
    context,
    {
      recebedor,
      ativos,
      transferenciaUuid,
      autorizadorId,
      autorizadorNome,
      autorizadorAuthType,
      autorizadorAuthContent,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/transferencia/${transferenciaUuid}/receber`,
      {
        recebedor,
        ativos,
        autorizadorId,
        autorizadorNome,
        autorizadorAuthType,
        autorizadorAuthContent,
      }
    );

    return response;
  },

  cancelarTransferencia: async (context, { cancelador, transferenciaUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/transferencia/${transferenciaUuid}/cancelar`,
      {
        cancelador,
      }
    );

    return response;
  },

  vincularAtivoTransferencia: async (
    context,
    { transferenciaUuid, ativos, usuarioId, usuarioNome }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/transferencia/${transferenciaUuid}/vincular-ativos`,
      {
        ativos,
        usuarioId,
        usuarioNome,
      }
    );

    return response;
  },
  receberDadosFichaCautela: async (context, { vendor_id, funcionarioId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/emprestimo/${vendor_id}/ficha`, {
      params: {
        vendor_id,
        funcionarioId,
      },
    });

    return response;
  },

  editarFichaCautela: async (context, { vendor_id, titulo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/emprestimo/${vendor_id}/ficha`, {
      titulo,
    });

    return response;
  },

  editarDadosFichaCautela: async (
    context,
    { titulo, subtitulo, dizeres, vendor_id }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`/atv/emprestimo/${vendor_id}/ficha`, {
      titulo,
      subtitulo,
      dizeres,
    });

    return response;
  },

  duplicarDadosFichaCautela: async (context, { vendor_id, vendor_id_alvo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `/atv/emprestimo/${vendor_id}/ficha/${vendor_id_alvo}`
    );

    return response;
  },

  excluirTransferenciaInterna: async (context, { uuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`rota/${uuid}`);

    return response;
  },

  listarChecklist: async (
    context,
    { nome, perPage, page, catalogoItemUuid, ativoUuid, catalogoUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/checklist`, {
      params: {
        catalogoUuid,
        nome,
        perPage,
        page,
        catalogoItemUuid,
        ativoUuid,
      },
    });

    return response;
  },

  adicionarChecklist: async (
    context,
    { nome, descricao, usuarioId, usuarioNome, catalogoUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/checklist`, {
      nome,
      descricao,
      usuarioId,
      usuarioNome,
      catalogoUuid,
    });

    return response;
  },

  editarChecklist: async (context, { nome, descricao, checkListUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/checklist/${checkListUuid}`, {
      nome,
      descricao,
    });

    return response;
  },

  excluirChecklist: async (context, { checkListUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`atv/checklist/${checkListUuid}`);

    return response;
  },

  //Configurações

  listarStatusAtivos: async (
    context,
    {
      status,
      unidadeId,
      catalogoUuid = context.rootState.ferramentaria.catalogoUuid,
    }
  ) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.get(`atv/ativo/status`, {
      params: {
        catalogoUuid,
        unidadeId,
        status,
      },
    });

    return response;
  },

  criarStatusAtivo: async (context, { status, unidadeId, catalogoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/ativo/status`, {
      catalogoUuid,
      status,
      unidadeId,
    });

    return response;
  },

  excluirStatusAtivo: async (context, { status, catalogoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`atv/ativo/status/${status}`, {
      params: {
        catalogoUuid,
      },
    });

    return response;
  },

  listarFuncionarios2: async (context, { search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        search,
      },
    });

    return response;
  },

  listarFuncionarios: async (
    context,
    { card_id, unidadeId, search, per_page, page, deleted }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get("auth/users", {
      params: {
        card_id,
        unidadeId,
        search,
        deleted,
        per_page,
        page,
      },
    });

    const funcionarios = [];

    response.data.results.data.forEach((funcionario) => {
      funcionarios.push(
        new Funcionario({
          id: funcionario.sap,
          idTabela: funcionario.id,
          nome: funcionario.name,
          matricula: funcionario.sap,
          biometria: funcionario.biometry,
          biometria_facial: funcionario.biometria_facial,
          centroCusto: funcionario.cost_center_id,
          centroCustoCode: funcionario?.cost_center?.code,
          centroCustoName: funcionario?.cost_center?.name,
        })
      );
    });

    return {
      funcionarios,
    };
  },

  // Retirada
  criarEmprestimo: async (
    context,
    {
      unidadeId,
      reservaUuid,
      solicitanteId,
      almoxId,
      solicitanteAuthType,
      solicitanteAuthContent,
      solicitanteNome,
      almoxNome,
      almoxAuthType,
      almoxAuthContent,
      comentarioRetirada,
      ativos,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/emprestimo`, {
      unidadeId,
      reservaUuid,
      almoxId,
      solicitanteId,
      solicitanteAuthType,
      solicitanteAuthContent,
      almoxAuthType,
      almoxAuthContent,
      comentarioRetirada,
      ativos,
      solicitanteNome,
      almoxNome,
    });

    return response;
  },

  // Devolucao
  listarEmprestimo: async (
    context,
    {
      ordenacao,
      unidadeId,
      solicitanteId,
      ativoDevolvido,
      acessorios,
      codigo,
      nome,
      patrimonio,
      nomeGrupo,
      nomeSubgrupo,
      page,
      perPage,
      comCheckLists,
      comAtributos,
      comAcessorios,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/emprestimo/ativo`, {
      params: {
        ordenacao,
        unidadeId,
        solicitanteId,
        ativoDevolvido,
        acessorios,
        codigo,
        nome,
        patrimonio,
        nomeGrupo,
        nomeSubgrupo,
        page,
        perPage,
        comCheckLists,
        comAtributos,
        comAcessorios,
      },
    });

    return response;
  },

  devolverEmprestimo: async (
    context,
    {
      unidadeIdDevolucao,
      solicitanteId,
      solicitanteAuthType,
      solicitanteAuthContent,
      almoxId,
      almoxAuthType,
      almoxAuthContent,
      ativos,
      solicitanteNome,
      almoxNome,
      comentarioDevolucao,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/emprestimo/devolucao`, {
      unidadeIdDevolucao,
      solicitanteId,
      solicitanteAuthType,
      solicitanteAuthContent,
      almoxId,
      almoxAuthType,
      almoxAuthContent,
      ativos,
      solicitanteNome,
      almoxNome,
      comentarioDevolucao,
    });

    return response;
  },

  buscarUrlEmprestimoAutenticacao: async (context, { nomeArquivo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/emprestimo/autenticacao/url-upload`, {
      params: {
        nomeArquivo,
      },
    });

    return response;
  },

  //Lista Reserva
  listarReservaCriada: async (
    context,
    {
      unidadeId,
      reservaUuid,
      solicitanteId,
      numeroReserva,
      page,
      perPage,
      criadoEm,
      status,
      finalizadoEm,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/reserva`, {
      params: {
        unidadeId,
        numeroReserva,
        reservaUuid,
        solicitanteId,
        criadoEm,
        page,
        perPage,
        status,
        finalizadoEm,
      },
    });

    return response;
  },

  excluirReserva: async (context, { reservaUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`atv/reserva/${reservaUuid}`);

    return response;
  },
  // Fazer Reserva
  adicionarReserva: async (
    context,
    {
      unidadeId,
      solicitanteId,
      almoxRequisitante,
      catalogoItens,
      almoxRequisitanteNome,
      solicitanteNome,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/reserva`, {
      unidadeId,
      solicitanteId,
      almoxRequisitante,
      solicitanteNome,
      almoxRequisitanteNome,
      catalogoItens,
    });

    return response;
  },

  //Detalhe Reserva
  excluirItemReserva: async (context, { reservaUuid, catalogoItemUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/reserva/${reservaUuid}/item/${catalogoItemUuid}`
    );

    return response;
  },

  // Criar Ferramenta por Estoque
  listarProdutosEstoque: async (
    context,
    { has_ca, per_page, page, search }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`products`, {
      params: {
        has_ca,
        page,
        per_page,
        search,
      },
    });

    return response;
  },

  //Movimentar Status
  listarAtivo: async (
    context,
    {
      ordenacao,
      unidadeId,

      catalogoItemUuid,
      uuidGrupo,
      uuidSubgrupo,
      comCheckLists,
      comAtributos,
      comAcessorios,
      perPage,
      page,
      ativoUuid,
      status,
      codigo,
      nome,
      patrimonio,
      nomeGrupo,
      nomeSubgrupo,
      comFornecedorAlocado,
      excluido,
      comMovimentacaoPermitida,
      fornecedorAlocado,
      fornecedorId,
      comItemsDeletados,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo`, {
      params: {
        unidadeId,
        ordenacao,
        perPage,
        page,
        ativoUuid,
        catalogoItemUuid,
        comAcessorios,
        uuidGrupo,
        uuidSubgrupo,
        comCheckLists,
        comAtributos,
        status,
        comMovimentacaoPermitida,
        codigo,
        nome,
        excluido,
        patrimonio,
        nomeGrupo,
        nomeSubgrupo,
        comFornecedorAlocado,
        fornecedorAlocado,
        fornecedorId,
        comItemsDeletados,
      },
    });

    const listaAtivo = [];
    response.data.resultado.dados.forEach((value) => {
      listaAtivo.push(
        new Ativo({
          ativoUuid: value.ativoUuid,
          codigo: value?.catalogoItem?.codigo,
          descricao: value?.catalogoItem?.nome,
          grupo: value?.catalogoItem?.catalogoGrupo,
          subgrupo: value?.catalogoItem?.catalogoSubGrupo,
          url: value.urlImagem,
          unidadeMedida: value.unidadeMedida,
          checkLists: value.checkLists,
          origem: value.origem,
          patrimonio: value.patrimonio,
          status: value.status,
          tempoPermanencia: value.tempoPermanencia,
          atributos: value.atributos,
          acessorios: value.acessorios,
          deposito: value?.deposito?.local,
          valor: value?.preco,
          fornecedorId: value?.fornecedorId,
          responsavelId: value.responsavelId,
          documentoNumero: value.documentoNumero,
          documentoSerie: value.documentoSerie,
          documentoTipo: value.documentoTipo,
          documentosVinculados: value.documentosVinculados,
          fornecedorNome: value?.fornecedorNome,
        })
      );
    });
    return { response, listaAtivo };
  },

  listarAtivoBloqueado: async (
    context,
    {
      unidadeId,
      ordenacao,
      catalogoItemUuid,
      funcionarioId,
      comCheckLists,
      comAtributos,
      comAcessorios,
      perPage,
      page,
      ativoUuid,
      status,
      codigo,
      nome,
      patrimonio,
      nomeGrupo,
      nomeSubgrupo,
      comFornecedorAlocado,
      excluido,
      comMovimentacaoPermitida,
      fornecedorAlocado,
      fornecedorId,
      comItemsDeletados,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/ativos-bloqueados`, {
      params: {
        unidadeId,
        ordenacao,
        perPage,
        page,
        ativoUuid,
        catalogoItemUuid,
        comAcessorios,
        funcionarioId,
        comCheckLists,
        comAtributos,
        status,
        comMovimentacaoPermitida,
        codigo,
        nome,
        excluido,
        patrimonio,
        nomeGrupo,
        nomeSubgrupo,
        comFornecedorAlocado,
        fornecedorAlocado,
        fornecedorId,
        comItemsDeletados,
      },
    });

    const listaAtivo = response.data.resultado.dados.map((value) => {
      return {
        ativoUuid: value.ativoUuid,
        codigo: value?.catalogoItem?.codigo,
        descricao: value?.catalogoItem?.nome,
        grupo: value?.catalogoItem?.catalogoGrupo,
        subgrupo: value?.catalogoItem?.catalogoSubGrupo,
        url: value.urlImagem,
        unidadeMedida: value.unidadeMedida,
        checkLists: value.checkLists,
        origem: value.origem,
        patrimonio: value.patrimonio,
        status: value.status,
        tempoPermanencia: value.tempoPermanencia,
        atributos: value.atributos,
        acessorios: value.acessorios,
        deposito: value?.deposito?.local,
        valor: value?.preco,
        fornecedorId: value?.fornecedorId,
        responsavelId: value.responsavelId,
        documentoNumero: value.documentoNumero,
        documentoSerie: value.documentoSerie,
        documentoTipo: value.documentoTipo,
        documentosVinculados: value.documentosVinculados,
        fornecedorNome: value?.fornecedorNome,
        bloqueio: value?.bloqueio,
      };
    });
    return { response, listaAtivo };
  },

  movimentarStatusAtivo: async (
    context,
    {
      novoStatus,
      motivo,
      anexos,
      ativos,
      usuarioId,
      usuarioNome,
      movimentarAtivoExterno,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/ativo/alterar-status`, {
      novoStatus,
      motivo,
      ativos,
      anexos,
      usuarioId,
      usuarioNome,
      movimentarAtivoExterno,
    });
    return response;
  },

  buscarUrlUploadMovimentacao: async (context, { nomeArquivo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/historico/anexos/url-upload`, {
      params: {
        nomeArquivo,
      },
    });
    return response;
  },

  ativoAtrasado: async (context, { unidadeId, funcionarioId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/emprestimo/ativo-atrasado`, {
      params: {
        unidadeId,
        funcionarioId,
      },
    });
    return response;
  },

  //Detalhe Movimentação
  receberDadoMovimentacaoStatus: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`rota`, {
      ferramentaId: 1,
    });
    return response;
  },

  listarMovimentacaoAtivo: async (
    context,
    { ativoUuid, perPage, page, etapa, chave, alteradoEm, fornecedorAlocado }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/${ativoUuid}/historico`, {
      params: {
        etapa,
        chave,
        alteradoEm,
        fornecedorAlocado,
        perPage,
        page,
      },
    });
    return response;
  },

  //Setup Catalogo
  configuracaoCatalogo: async (context, { catalogoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/catalogo/${catalogoUuid}/configuracao`);

    return response;
  },

  salvarConfiguracao: async (context, { catalogoUuid, configuracoes }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/catalogo/${catalogoUuid}/configuracao`,
      {
        configuracoes,
      }
    );

    return response;
  },

  listarUnidadeCatalogo: async (context, { catalogoUuid, unidadeId, nome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/unidade`, {
      params: {
        catalogoUuid,
        unidadeId,
        nome,
      },
    });

    return response;
  },

  associarUnidadeCatalogo: async (context, { catalogoUuid, unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/catalogo/${catalogoUuid}/unidade/${unidadeId}/associar`
    );

    return response;
  },

  desassociarUnidadeCatalogo: async (context, { catalogoUuid, unidadeId }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/catalogo/${catalogoUuid}/unidade/${unidadeId}/desassociar`
    );

    return response;
  },

  //Componente Autenticação
  receberUserLogado: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/auth/me`);

    return response;
  },

  //Configurações Deposito
  listarDeposito: async (context, { unidadeId, nomeLocal, nome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`org/deposito`, {
      params: {
        unidadeId,
        nome,
        nomeLocal,
      },
    });

    return response;
  },

  criarDeposito: async (context, { unidadeId, nome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`org/deposito`, {
      unidadeId,
      nome,
    });

    return response;
  },

  criarDepositoLocal: async (context, { depositoUuid, local }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`org/deposito/local`, {
      depositoUuid,
      local,
    });

    return response;
  },

  excluirDeposito: async (context, { depositoUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`org/deposito/${depositoUuid}`);

    return response;
  },

  excluirDepositoLocal: async (context, { depositoLocalUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `org/deposito/local/${depositoLocalUuid}`
    );

    return response;
  },

  //Configuração Operação
  listarOperacao: async (context, { catalogoUuid, nome }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/transferencia/operacao`, {
      params: {
        catalogoUuid,
        nome,
      },
    });

    return response;
  },

  excluirOperacao: async (
    context,
    { transferenciaOperacaoUuid, catalogoUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/transferencia/operacao/${transferenciaOperacaoUuid}`,
      {
        params: {
          catalogoUuid,
        },
      }
    );

    return response;
  },

  adcionarOperacao: async (context, { catalogoUuid, nome, descricao }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/transferencia/operacao`, {
      catalogoUuid,
      nome,
      descricao,
    });

    return response;
  },

  excluirOperacaoTransferencia: async (context, { transferenciaUuid }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`atv/reserva/${transferenciaUuid}`, {
      transferenciaUuid,
    });

    return response;
  },
  //relatorios

  relatorioCatalogo: async (
    context,
    { codigo, grupo, subgrupo, catalogoUuid, descricao }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/catalogo/relatorio`, {
      params: {
        codigo,
        grupo,
        subgrupo,
        catalogoUuid,
        descricao,
      },
    });

    return response;
  },

  relatorioAtivos: async (
    context,
    { codigo, grupo, subgrupo, origem, unidade, descricao, background, status }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/relatorio`, {
      params: {
        origem,
        codigo,
        grupo,
        subgrupo,
        unidade,
        descricao,
        background,
        status,
      },
    });

    return response;
  },

  relatorioAtivosExternos: async (
    context,
    { fornecedor, numero, codigo, patrimonio }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/relatorioExterno`, {
      params: {
        fornecedor,
        numero,
        codigo,
        patrimonio,
      },
    });

    return response;
  },

  relatorioCatalogoSimplificado: async (
    context,
    { unidade, codigo, descricao, grupo, subgrupo }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/catalogo/relatorioSimplificado`, {
      params: {
        unidade,
        codigo,
        descricao,
        grupo,
        subgrupo,
      },
    });

    return response;
  },

  relatorioAtivosSimplificado: async (
    context,
    { codigo, grupo, subgrupo, unidade, descricao }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/relatorioSimplificado`, {
      params: {
        codigo,
        grupo,
        subgrupo,
        unidade,
        descricao,
      },
    });

    return response;
  },

  relatorioEmprestimo: async (
    context,
    {
      codigo,
      dataRetirada,
      dataDevolucao,
      solicitante,
      unidade,
      descricao,
      tempoExcedido,
      centroCusto,
      abertos,
      background,
      origem,
      patrimonio,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/emprestimo/relatorio`, {
      params: {
        codigo,
        dataRetirada,
        dataDevolucao,
        solicitante,
        unidade,
        descricao,
        tempoExcedido,
        centroCusto,
        abertos,
        background,
        origem,
        patrimonio,
      },
    });

    return response;
  },

  relatorioEmprestimoNotificacao: async (context, { url }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`${url}`);

    return response;
  },

  relatorioMovimentacao: async (
    context,
    {
      unidade,
      origem,
      codigo,
      grupo,
      subgrupo,
      documentoEntrada,
      dataEntrada,
      documentoSaida,
      dataSaida,
      numeroTransferencia,
      descricao,
      background,
      patrimonio,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/transferencia/relatorio`, {
      params: {
        unidade,
        origem,
        codigo,
        grupo,
        subgrupo,
        documentoEntrada,
        dataEntrada,
        documentoSaida,
        dataSaida,
        numeroTransferencia,
        descricao,
        background,
        patrimonio,
      },
    });

    return response;
  },

  relatorioMedicao: async (
    context,
    { dataInicial, dataFinal, fornecedor, background }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`/atv/transferencia/relatorioMedicao`, {
      params: {
        dataInicial,
        dataFinal,
        fornecedor,
        background,
      },
    });

    return response;
  },

  relatorioStatusManual: async (
    context,
    {
      unidade,

      codigo,
      grupo,
      subgrupo,
      patrimonio,
      dataInicial,

      dataFinal,

      descricao,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/ativo/relatorioStatusManual`, {
      params: {
        unidade,
        codigo,
        descricao,
        grupo,
        subgrupo,
        patrimonio,
        dataInicial,

        dataFinal,
      },
    });

    return response;
  },

  relatorioChecklistAcessorio: async (
    context,
    {
      unidade,
      fornecedorAlocado,
      codigo,
      descricao,
      patrimonio,
      tipoMovimento,
      numero,
      dataInicial,
      dataFinal,
      background,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/checklist/relatorio`, {
      params: {
        unidade,
        fornecedorAlocado,
        codigo,
        descricao,
        patrimonio,
        tipoMovimento,
        numero,
        dataInicial,
        dataFinal,
        background,
      },
    });

    return response;
  },

  relatorioChecklistAcessorioNotificacao: async (context, { url }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`${url}`);

    return response;
  },

  // Relatorio de Cautela;
  getCautela: async (
    context,
    {
      unidadeId,
      unidadeModeloId,
      funcionarioId,
      deletado,
      dataInicial,
      dataFinal,
      emAberto,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/emprestimo/${unidadeModeloId}/ficha`, {
      params: {
        unidadeId,
        funcionarioId,
        dataInicial,
        dataFinal,
        deletado,
        emAberto,
      },
    });

    return response;
  },
  listarAnexoFuncionario: async (context, { funcionarioId, page, perPage }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/funcionario/anexo`, {
      params: {
        funcionarioId,
        page,
        perPage,
      },
    });

    return response;
  },

  buscarUrlAnexoFicha: async (context, { funcionarioId, nomeArquivo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/funcionario/anexo/url-upload`, {
      params: {
        funcionarioId,
        nomeArquivo,
      },
    });

    return response;
  },

  desvincularAtivos: async (context, { transferenciaUuid, ativos }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(
      `atv/transferencia/${transferenciaUuid}/desvincular-ativos`,
      {
        ativos,
      }
    );

    return response;
  },

  adicionarAnexoFuncionario: async (
    context,
    {
      catalogoUuid,
      nome,
      descricao,
      usuarioId,
      usuarioNome,
      funcionarioId,
      funcionarioNome,
      urlAnexo,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/funcionario/anexo`, {
      catalogoUuid,
      nome,
      descricao,
      usuarioId,
      usuarioNome,
      funcionarioId,
      funcionarioNome,
      urlAnexo,
    });

    return response;
  },

  listarAlertasCriados: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/alerta`);

    return response;
  },

  criarAlerta: async (
    context,
    { entidade, entidadeUuid, app, email, habilitado }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/alerta`, {
      entidade,
      entidadeUuid,
      app,
      email,
      habilitado,
    });

    return response;
  },

  listarRegrasCriadas: async (
    context,
    { unidadeId, catalogoUuid, page, per_page }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/limite-tempo-permanencia`, {
      params: {
        unidadeId,
        catalogoUuid,
        page,
        perPage: per_page,
      },
    });

    return response;
  },

  criarRegra: async (
    context,
    { catalogoUuid, agrupadorTipo, agrupadorUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/limite-tempo-permanencia `, {
      catalogoUuid,
      agrupadorTipo,
      agrupadorUuid,
    });

    return response;
  },

  excluirRegra: async (
    context,
    { catalogoUuid, agrupadorTipo, agrupadorUuid }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(
      `atv/limite-tempo-permanencia/${catalogoUuid}`,
      {
        params: {
          agrupadorTipo,
          agrupadorUuid,
        },
      }
    );

    return response;
  },

  logsSetup: async (
    context,
    {
      unidadeId,
      catalogoUuid,
      page,
      per_page,
      dataInicial,
      dataFinal,
      usuarioId,
    }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/planilha/log`, {
      params: {
        unidadeId,
        catalogoUuid,
        page,
        perPage: per_page,
        dataInicial,
        dataFinal,
        usuarioId,
      },
    });

    return response;
  },
  logsSetupDetalhe: async (context, { logId, sucesso }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/planilha/log/${logId}`, {
      params: {
        sucesso,
      },
    });

    return response;
  },

  uploadItemCatalogoPlanilha: async (
    context,
    { url, catalogoUuid, usuarioId, usuarioNome, unidadeId, background }
  ) => {
    const api = context.rootState.autenticacao.api;

    const response = await api.post(`atv/catalogo/item/planilha`, {
      url,
      catalogoUuid,
      usuarioId,
      usuarioNome,
      unidadeId,
      background,
    });

    return response;
  },

  uploadAtivosPlanilha: async (
    context,
    { url, catalogoUuid, usuarioId, usuarioNome, unidadeId, background }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.post(`atv/ativo/planilha`, {
      url,
      catalogoUuid,
      usuarioId,
      usuarioNome,
      unidadeId,
      background,
    });

    return response;
  },

  deleteAtivosPlanilha: async (
    context,
    { url, catalogoUuid, usuarioId, usuarioNome, unidadeId, background }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.delete(`atv/ativo/planilha`, {
      data: {
        url,
        catalogoUuid,
        usuarioId,
        usuarioNome,
        unidadeId,
        background,
      },
    });

    return response;
  },

  uploadAcessorioItemCatalogoPlanilha: async (
    context,
    { url, catalogoUuid, usuarioId, usuarioNome, unidadeId, background }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/catalogo/item/acessorio/planilha`, {
      url,
      catalogoUuid,
      usuarioId,
      usuarioNome,
      unidadeId,
      background,
    });

    return response;
  },

  uploadAtributoItemCatalogoPlanilha: async (
    context,
    { url, catalogoUuid, usuarioId, usuarioNome, unidadeId, background }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/catalogo/item/atributo/planilha`, {
      url,
      catalogoUuid,
      usuarioId,
      usuarioNome,
      unidadeId,
      background,
    });

    return response;
  },

  uploadChecklistItemCatalogoPlanilha: async (
    context,
    { url, catalogoUuid, usuarioId, usuarioNome, unidadeId, background }
  ) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.put(`atv/catalogo/item/checklist/planilha`, {
      url,
      catalogoUuid,
      usuarioId,
      usuarioNome,
      unidadeId,
      background,
    });

    return response;
  },

  listarTiposPlanilha: async (context) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/planilha`);
    return response;
  },

  buscarUrlUploadPlanilha: async (context, { planilhaTipo, nomeArquivo }) => {
    const api = context.rootState.autenticacao.api;
    const response = await api.get(`atv/planilha/uploadPlanilha`, {
      params: {
        planilhaTipo,
        nomeArquivo,
      },
    });
    return response;
  },
};

export const ferramentaria = {
  namespaced: true,
  actions,
  state,
  mutations,
};
